var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp-footer"},[_c('div',{staticClass:"icp-container"},[_c('img',{staticClass:"guohui-icon",attrs:{"src":require("@/assets/imgs/guohui.png"),"alt":"国徽"}}),_c('a',{staticClass:"icp-link",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" 蜀ICP备2021019044号-12 ")])])])
}]

export { render, staticRenderFns }